"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationItem = exports.PaginationButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _Text = require("../Text");
var _PaginationModule = _interopRequireDefault(require("./Pagination.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PaginationButton = props => {
  const {
    disabled,
    onClick,
    page,
    selected,
    type,
    testId
  } = props;
  const paginationBtnRef = React.useRef(null);
  React.useEffect(() => {
    if (selected) {
      paginationBtnRef.current?.blur();
    }
  }, [selected]);
  switch (type) {
    case 'first':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        classNames: {
          icon: (0, _classify.default)(_PaginationModule.default.icon, {
            [_PaginationModule.default.disabled]: disabled
          }),
          wrapper: (0, _classify.default)(_PaginationModule.default.paginatorButton, {
            [_PaginationModule.default.disabled]: disabled
          })
        },
        type: selected ? 'secondary' : 'ghost',
        size: "small",
        onClick: onClick,
        disabled: disabled,
        ref: paginationBtnRef,
        iconLeftName: "chevrons-left",
        ariaLabel: "First page",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'first'
        })
      });
    case 'previous':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        classNames: {
          icon: (0, _classify.default)(_PaginationModule.default.icon, {
            [_PaginationModule.default.disabled]: disabled
          }),
          wrapper: (0, _classify.default)(_PaginationModule.default.paginatorButton, {
            [_PaginationModule.default.disabled]: disabled
          })
        },
        type: selected ? 'secondary' : 'ghost',
        size: "small",
        onClick: onClick,
        disabled: disabled,
        ref: paginationBtnRef,
        iconLeftName: "chevron-left",
        ariaLabel: "Previous page",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'previous'
        })
      });
    case 'page':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        classNames: {
          wrapper: (0, _classify.default)(_PaginationModule.default.paginatorButton, {
            [_PaginationModule.default.selected]: selected
          })
        },
        type: selected ? 'secondary' : 'ghost',
        size: "small",
        onClick: onClick,
        disabled: disabled,
        ref: paginationBtnRef,
        tabIndex: selected ? -1 : 0,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: `page-${page}`
        }),
        children: page
      });
    case 'start-ellipsis':
    case 'end-ellipsis':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classify.default)(_PaginationModule.default.separator),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: type
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.ButtonTextSmall, {
          color: "disabled",
          children: "..."
        })
      });
    case 'next':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        classNames: {
          icon: (0, _classify.default)(_PaginationModule.default.icon, {
            [_PaginationModule.default.disabled]: disabled
          }),
          wrapper: (0, _classify.default)(_PaginationModule.default.paginatorButton, {
            [_PaginationModule.default.disabled]: disabled
          })
        },
        type: selected ? 'secondary' : 'ghost',
        size: "small",
        onClick: onClick,
        disabled: disabled,
        ref: paginationBtnRef,
        iconLeftName: "chevron-right",
        ariaLabel: "Next page",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'next'
        })
      });
    case 'last':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        classNames: {
          icon: (0, _classify.default)(_PaginationModule.default.icon, {
            [_PaginationModule.default.disabled]: disabled
          }),
          wrapper: (0, _classify.default)(_PaginationModule.default.paginatorButton, {
            [_PaginationModule.default.disabled]: disabled
          })
        },
        type: selected ? 'secondary' : 'ghost',
        size: "small",
        onClick: onClick,
        disabled: disabled,
        ref: paginationBtnRef,
        iconLeftName: "chevrons-right",
        ariaLabel: "Last page",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'last'
        })
      });
    default:
      break;
  }
};
exports.PaginationButton = PaginationButton;
const PaginationItem = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(PaginationButton, {
  ...props
});
exports.PaginationItem = PaginationItem;